"use strict";

/**
 * This class a bunch of blosum matricies. Taken from the biopython project:
 *
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
var constructSubstitutionMatrix = function constructSubstitutionMatrix(arr) {
  return arr.reduce(function (acc, matInput) {
    if (!acc.has(matInput.letterA)) {
      acc.set(matInput.letterA, new Map());
    }
    if (!acc.has(matInput.letterB)) {
      acc.set(matInput.letterB, new Map());
    }
    acc.get(matInput.letterA).set(matInput.letterB, matInput.score);
    acc.get(matInput.letterB).set(matInput.letterA, matInput.score);
    return acc;
  }, new Map());
};
exports.BLOSUM62 = constructSubstitutionMatrix([{
  letterA: "W",
  letterB: "F",
  score: 1
}, {
  letterA: "L",
  letterB: "R",
  score: -2
}, {
  letterA: "S",
  letterB: "P",
  score: -1
}, {
  letterA: "V",
  letterB: "T",
  score: 0
}, {
  letterA: "Q",
  letterB: "Q",
  score: 5
}, {
  letterA: "N",
  letterB: "A",
  score: -2
}, {
  letterA: "Z",
  letterB: "Y",
  score: -2
}, {
  letterA: "W",
  letterB: "R",
  score: -3
}, {
  letterA: "Q",
  letterB: "A",
  score: -1
}, {
  letterA: "S",
  letterB: "D",
  score: 0
}, {
  letterA: "H",
  letterB: "H",
  score: 8
}, {
  letterA: "S",
  letterB: "H",
  score: -1
}, {
  letterA: "H",
  letterB: "D",
  score: -1
}, {
  letterA: "L",
  letterB: "N",
  score: -3
}, {
  letterA: "W",
  letterB: "A",
  score: -3
}, {
  letterA: "Y",
  letterB: "M",
  score: -1
}, {
  letterA: "G",
  letterB: "R",
  score: -2
}, {
  letterA: "Y",
  letterB: "I",
  score: -1
}, {
  letterA: "Y",
  letterB: "E",
  score: -2
}, {
  letterA: "B",
  letterB: "Y",
  score: -3
}, {
  letterA: "Y",
  letterB: "A",
  score: -2
}, {
  letterA: "V",
  letterB: "D",
  score: -3
}, {
  letterA: "B",
  letterB: "S",
  score: 0
}, {
  letterA: "Y",
  letterB: "Y",
  score: 7
}, {
  letterA: "G",
  letterB: "N",
  score: 0
}, {
  letterA: "E",
  letterB: "C",
  score: -4
}, {
  letterA: "Y",
  letterB: "Q",
  score: -1
}, {
  letterA: "Z",
  letterB: "Z",
  score: 4
}, {
  letterA: "V",
  letterB: "A",
  score: 0
}, {
  letterA: "C",
  letterB: "C",
  score: 9
}, {
  letterA: "M",
  letterB: "R",
  score: -1
}, {
  letterA: "V",
  letterB: "E",
  score: -2
}, {
  letterA: "T",
  letterB: "N",
  score: 0
}, {
  letterA: "P",
  letterB: "P",
  score: 7
}, {
  letterA: "V",
  letterB: "I",
  score: 3
}, {
  letterA: "V",
  letterB: "S",
  score: -2
}, {
  letterA: "Z",
  letterB: "P",
  score: -1
}, {
  letterA: "V",
  letterB: "M",
  score: 1
}, {
  letterA: "T",
  letterB: "F",
  score: -2
}, {
  letterA: "V",
  letterB: "Q",
  score: -2
}, {
  letterA: "K",
  letterB: "K",
  score: 5
}, {
  letterA: "P",
  letterB: "D",
  score: -1
}, {
  letterA: "I",
  letterB: "H",
  score: -3
}, {
  letterA: "I",
  letterB: "D",
  score: -3
}, {
  letterA: "T",
  letterB: "R",
  score: -1
}, {
  letterA: "P",
  letterB: "L",
  score: -3
}, {
  letterA: "K",
  letterB: "G",
  score: -2
}, {
  letterA: "M",
  letterB: "N",
  score: -2
}, {
  letterA: "P",
  letterB: "H",
  score: -2
}, {
  letterA: "F",
  letterB: "Q",
  score: -3
}, {
  letterA: "Z",
  letterB: "G",
  score: -2
}, {
  letterA: "X",
  letterB: "L",
  score: -1
}, {
  letterA: "T",
  letterB: "M",
  score: -1
}, {
  letterA: "Z",
  letterB: "C",
  score: -3
}, {
  letterA: "X",
  letterB: "H",
  score: -1
}, {
  letterA: "D",
  letterB: "R",
  score: -2
}, {
  letterA: "B",
  letterB: "W",
  score: -4
}, {
  letterA: "X",
  letterB: "D",
  score: -1
}, {
  letterA: "Z",
  letterB: "K",
  score: 1
}, {
  letterA: "F",
  letterB: "A",
  score: -2
}, {
  letterA: "Z",
  letterB: "W",
  score: -3
}, {
  letterA: "F",
  letterB: "E",
  score: -3
}, {
  letterA: "D",
  letterB: "N",
  score: 1
}, {
  letterA: "B",
  letterB: "K",
  score: 0
}, {
  letterA: "X",
  letterB: "X",
  score: -1
}, {
  letterA: "F",
  letterB: "I",
  score: 0
}, {
  letterA: "B",
  letterB: "G",
  score: -1
}, {
  letterA: "X",
  letterB: "T",
  score: 0
}, {
  letterA: "F",
  letterB: "M",
  score: 0
}, {
  letterA: "B",
  letterB: "C",
  score: -3
}, {
  letterA: "Z",
  letterB: "I",
  score: -3
}, {
  letterA: "Z",
  letterB: "V",
  score: -2
}, {
  letterA: "S",
  letterB: "S",
  score: 4
}, {
  letterA: "L",
  letterB: "Q",
  score: -2
}, {
  letterA: "W",
  letterB: "E",
  score: -3
}, {
  letterA: "Q",
  letterB: "R",
  score: 1
}, {
  letterA: "N",
  letterB: "N",
  score: 6
}, {
  letterA: "W",
  letterB: "M",
  score: -1
}, {
  letterA: "Q",
  letterB: "C",
  score: -3
}, {
  letterA: "W",
  letterB: "I",
  score: -3
}, {
  letterA: "S",
  letterB: "C",
  score: -1
}, {
  letterA: "L",
  letterB: "A",
  score: -1
}, {
  letterA: "S",
  letterB: "G",
  score: 0
}, {
  letterA: "L",
  letterB: "E",
  score: -3
}, {
  letterA: "W",
  letterB: "Q",
  score: -2
}, {
  letterA: "H",
  letterB: "G",
  score: -2
}, {
  letterA: "S",
  letterB: "K",
  score: 0
}, {
  letterA: "Q",
  letterB: "N",
  score: 0
}, {
  letterA: "N",
  letterB: "R",
  score: 0
}, {
  letterA: "H",
  letterB: "C",
  score: -3
}, {
  letterA: "Y",
  letterB: "N",
  score: -2
}, {
  letterA: "G",
  letterB: "Q",
  score: -2
}, {
  letterA: "Y",
  letterB: "F",
  score: 3
}, {
  letterA: "C",
  letterB: "A",
  score: 0
}, {
  letterA: "V",
  letterB: "L",
  score: 1
}, {
  letterA: "G",
  letterB: "E",
  score: -2
}, {
  letterA: "G",
  letterB: "A",
  score: 0
}, {
  letterA: "K",
  letterB: "R",
  score: 2
}, {
  letterA: "E",
  letterB: "D",
  score: 2
}, {
  letterA: "Y",
  letterB: "R",
  score: -2
}, {
  letterA: "M",
  letterB: "Q",
  score: 0
}, {
  letterA: "T",
  letterB: "I",
  score: -1
}, {
  letterA: "C",
  letterB: "D",
  score: -3
}, {
  letterA: "V",
  letterB: "F",
  score: -1
}, {
  letterA: "T",
  letterB: "A",
  score: 0
}, {
  letterA: "T",
  letterB: "P",
  score: -1
}, {
  letterA: "B",
  letterB: "P",
  score: -2
}, {
  letterA: "T",
  letterB: "E",
  score: -1
}, {
  letterA: "V",
  letterB: "N",
  score: -3
}, {
  letterA: "P",
  letterB: "G",
  score: -2
}, {
  letterA: "M",
  letterB: "A",
  score: -1
}, {
  letterA: "K",
  letterB: "H",
  score: -1
}, {
  letterA: "V",
  letterB: "R",
  score: -3
}, {
  letterA: "P",
  letterB: "C",
  score: -3
}, {
  letterA: "M",
  letterB: "E",
  score: -2
}, {
  letterA: "K",
  letterB: "L",
  score: -2
}, {
  letterA: "V",
  letterB: "V",
  score: 4
}, {
  letterA: "M",
  letterB: "I",
  score: 1
}, {
  letterA: "T",
  letterB: "Q",
  score: -1
}, {
  letterA: "I",
  letterB: "G",
  score: -4
}, {
  letterA: "P",
  letterB: "K",
  score: -1
}, {
  letterA: "M",
  letterB: "M",
  score: 5
}, {
  letterA: "K",
  letterB: "D",
  score: -1
}, {
  letterA: "I",
  letterB: "C",
  score: -1
}, {
  letterA: "Z",
  letterB: "D",
  score: 1
}, {
  letterA: "F",
  letterB: "R",
  score: -3
}, {
  letterA: "X",
  letterB: "K",
  score: -1
}, {
  letterA: "Q",
  letterB: "D",
  score: 0
}, {
  letterA: "X",
  letterB: "G",
  score: -1
}, {
  letterA: "Z",
  letterB: "L",
  score: -3
}, {
  letterA: "X",
  letterB: "C",
  score: -2
}, {
  letterA: "Z",
  letterB: "H",
  score: 0
}, {
  letterA: "B",
  letterB: "L",
  score: -4
}, {
  letterA: "B",
  letterB: "H",
  score: 0
}, {
  letterA: "F",
  letterB: "F",
  score: 6
}, {
  letterA: "X",
  letterB: "W",
  score: -2
}, {
  letterA: "B",
  letterB: "D",
  score: 4
}, {
  letterA: "D",
  letterB: "A",
  score: -2
}, {
  letterA: "S",
  letterB: "L",
  score: -2
}, {
  letterA: "X",
  letterB: "S",
  score: 0
}, {
  letterA: "F",
  letterB: "N",
  score: -3
}, {
  letterA: "S",
  letterB: "R",
  score: -1
}, {
  letterA: "W",
  letterB: "D",
  score: -4
}, {
  letterA: "V",
  letterB: "Y",
  score: -1
}, {
  letterA: "W",
  letterB: "L",
  score: -2
}, {
  letterA: "H",
  letterB: "R",
  score: 0
}, {
  letterA: "W",
  letterB: "H",
  score: -2
}, {
  letterA: "H",
  letterB: "N",
  score: 1
}, {
  letterA: "W",
  letterB: "T",
  score: -2
}, {
  letterA: "T",
  letterB: "T",
  score: 5
}, {
  letterA: "S",
  letterB: "F",
  score: -2
}, {
  letterA: "W",
  letterB: "P",
  score: -4
}, {
  letterA: "L",
  letterB: "D",
  score: -4
}, {
  letterA: "B",
  letterB: "I",
  score: -3
}, {
  letterA: "L",
  letterB: "H",
  score: -3
}, {
  letterA: "S",
  letterB: "N",
  score: 1
}, {
  letterA: "B",
  letterB: "T",
  score: -1
}, {
  letterA: "L",
  letterB: "L",
  score: 4
}, {
  letterA: "Y",
  letterB: "K",
  score: -2
}, {
  letterA: "E",
  letterB: "Q",
  score: 2
}, {
  letterA: "Y",
  letterB: "G",
  score: -3
}, {
  letterA: "Z",
  letterB: "S",
  score: 0
}, {
  letterA: "Y",
  letterB: "C",
  score: -2
}, {
  letterA: "G",
  letterB: "D",
  score: -1
}, {
  letterA: "B",
  letterB: "V",
  score: -3
}, {
  letterA: "E",
  letterB: "A",
  score: -1
}, {
  letterA: "Y",
  letterB: "W",
  score: 2
}, {
  letterA: "E",
  letterB: "E",
  score: 5
}, {
  letterA: "Y",
  letterB: "S",
  score: -2
}, {
  letterA: "C",
  letterB: "N",
  score: -3
}, {
  letterA: "V",
  letterB: "C",
  score: -1
}, {
  letterA: "T",
  letterB: "H",
  score: -2
}, {
  letterA: "P",
  letterB: "R",
  score: -2
}, {
  letterA: "V",
  letterB: "G",
  score: -3
}, {
  letterA: "T",
  letterB: "L",
  score: -1
}, {
  letterA: "V",
  letterB: "K",
  score: -2
}, {
  letterA: "K",
  letterB: "Q",
  score: 1
}, {
  letterA: "R",
  letterB: "A",
  score: -1
}, {
  letterA: "I",
  letterB: "R",
  score: -3
}, {
  letterA: "T",
  letterB: "D",
  score: -1
}, {
  letterA: "P",
  letterB: "F",
  score: -4
}, {
  letterA: "I",
  letterB: "N",
  score: -3
}, {
  letterA: "K",
  letterB: "I",
  score: -3
}, {
  letterA: "M",
  letterB: "D",
  score: -3
}, {
  letterA: "V",
  letterB: "W",
  score: -3
}, {
  letterA: "W",
  letterB: "W",
  score: 11
}, {
  letterA: "M",
  letterB: "H",
  score: -2
}, {
  letterA: "P",
  letterB: "N",
  score: -2
}, {
  letterA: "K",
  letterB: "A",
  score: -1
}, {
  letterA: "M",
  letterB: "L",
  score: 2
}, {
  letterA: "K",
  letterB: "E",
  score: 1
}, {
  letterA: "Z",
  letterB: "E",
  score: 4
}, {
  letterA: "X",
  letterB: "N",
  score: -1
}, {
  letterA: "Z",
  letterB: "A",
  score: -1
}, {
  letterA: "Z",
  letterB: "M",
  score: -1
}, {
  letterA: "X",
  letterB: "F",
  score: -1
}, {
  letterA: "K",
  letterB: "C",
  score: -3
}, {
  letterA: "B",
  letterB: "Q",
  score: 0
}, {
  letterA: "X",
  letterB: "B",
  score: -1
}, {
  letterA: "B",
  letterB: "M",
  score: -3
}, {
  letterA: "F",
  letterB: "C",
  score: -2
}, {
  letterA: "Z",
  letterB: "Q",
  score: 3
}, {
  letterA: "X",
  letterB: "Z",
  score: -1
}, {
  letterA: "F",
  letterB: "G",
  score: -3
}, {
  letterA: "B",
  letterB: "E",
  score: 1
}, {
  letterA: "X",
  letterB: "V",
  score: -1
}, {
  letterA: "F",
  letterB: "K",
  score: -3
}, {
  letterA: "B",
  letterB: "A",
  score: -2
}, {
  letterA: "X",
  letterB: "R",
  score: -1
}, {
  letterA: "D",
  letterB: "D",
  score: 6
}, {
  letterA: "W",
  letterB: "G",
  score: -2
}, {
  letterA: "Z",
  letterB: "F",
  score: -3
}, {
  letterA: "S",
  letterB: "Q",
  score: 0
}, {
  letterA: "W",
  letterB: "C",
  score: -2
}, {
  letterA: "W",
  letterB: "K",
  score: -3
}, {
  letterA: "H",
  letterB: "Q",
  score: 0
}, {
  letterA: "L",
  letterB: "C",
  score: -1
}, {
  letterA: "W",
  letterB: "N",
  score: -4
}, {
  letterA: "S",
  letterB: "A",
  score: 1
}, {
  letterA: "L",
  letterB: "G",
  score: -4
}, {
  letterA: "W",
  letterB: "S",
  score: -3
}, {
  letterA: "S",
  letterB: "E",
  score: 0
}, {
  letterA: "H",
  letterB: "E",
  score: 0
}, {
  letterA: "S",
  letterB: "I",
  score: -2
}, {
  letterA: "H",
  letterB: "A",
  score: -2
}, {
  letterA: "S",
  letterB: "M",
  score: -1
}, {
  letterA: "Y",
  letterB: "L",
  score: -1
}, {
  letterA: "Y",
  letterB: "H",
  score: 2
}, {
  letterA: "Y",
  letterB: "D",
  score: -3
}, {
  letterA: "E",
  letterB: "R",
  score: 0
}, {
  letterA: "X",
  letterB: "P",
  score: -2
}, {
  letterA: "G",
  letterB: "G",
  score: 6
}, {
  letterA: "G",
  letterB: "C",
  score: -3
}, {
  letterA: "E",
  letterB: "N",
  score: 0
}, {
  letterA: "Y",
  letterB: "T",
  score: -2
}, {
  letterA: "Y",
  letterB: "P",
  score: -3
}, {
  letterA: "T",
  letterB: "K",
  score: -1
}, {
  letterA: "A",
  letterB: "A",
  score: 4
}, {
  letterA: "P",
  letterB: "Q",
  score: -1
}, {
  letterA: "T",
  letterB: "C",
  score: -1
}, {
  letterA: "V",
  letterB: "H",
  score: -3
}, {
  letterA: "T",
  letterB: "G",
  score: -2
}, {
  letterA: "I",
  letterB: "Q",
  score: -3
}, {
  letterA: "Z",
  letterB: "T",
  score: -1
}, {
  letterA: "C",
  letterB: "R",
  score: -3
}, {
  letterA: "V",
  letterB: "P",
  score: -2
}, {
  letterA: "P",
  letterB: "E",
  score: -1
}, {
  letterA: "M",
  letterB: "C",
  score: -1
}, {
  letterA: "K",
  letterB: "N",
  score: 0
}, {
  letterA: "I",
  letterB: "I",
  score: 4
}, {
  letterA: "P",
  letterB: "A",
  score: -1
}, {
  letterA: "M",
  letterB: "G",
  score: -3
}, {
  letterA: "T",
  letterB: "S",
  score: 1
}, {
  letterA: "I",
  letterB: "E",
  score: -3
}, {
  letterA: "P",
  letterB: "M",
  score: -2
}, {
  letterA: "M",
  letterB: "K",
  score: -1
}, {
  letterA: "I",
  letterB: "A",
  score: -1
}, {
  letterA: "P",
  letterB: "I",
  score: -3
}, {
  letterA: "R",
  letterB: "R",
  score: 5
}, {
  letterA: "X",
  letterB: "M",
  score: -1
}, {
  letterA: "L",
  letterB: "I",
  score: 2
}, {
  letterA: "X",
  letterB: "I",
  score: -1
}, {
  letterA: "Z",
  letterB: "B",
  score: 1
}, {
  letterA: "X",
  letterB: "E",
  score: -1
}, {
  letterA: "Z",
  letterB: "N",
  score: 0
}, {
  letterA: "X",
  letterB: "A",
  score: 0
}, {
  letterA: "B",
  letterB: "R",
  score: -1
}, {
  letterA: "B",
  letterB: "N",
  score: 3
}, {
  letterA: "F",
  letterB: "D",
  score: -3
}, {
  letterA: "X",
  letterB: "Y",
  score: -1
}, {
  letterA: "Z",
  letterB: "R",
  score: 0
}, {
  letterA: "F",
  letterB: "H",
  score: -1
}, {
  letterA: "B",
  letterB: "F",
  score: -3
}, {
  letterA: "F",
  letterB: "L",
  score: 0
}, {
  letterA: "X",
  letterB: "Q",
  score: -1
}, {
  letterA: "B",
  letterB: "B",
  score: 4
}]);